import {
  FlexBox,
  HtmlButtonProps,
  IconButton,
  SelectionList,
  TextWithHighlight,
} from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import { memo, useCallback, useState } from 'react';

import {
  EnhancedTemplate,
  useQuickReplyData,
} from 'components/editorQuickRepliesDropdown/components/quickRepliesContent/util/useQuickReplyData';

import styles from './templateItem.module.scss';

interface TemplateListProps {
  item: EnhancedTemplate;
  toggleFavorite: ReturnType<typeof useQuickReplyData>['toggleFavorite'];
  searchTerm?: string;
  locale: string;
}

export const TemplateItem = memo(
  ({
    item,
    toggleFavorite,
    searchTerm,
    locale,
  }: TemplateListProps): JSX.Element => {
    const [isHovered, setIsHovered] = useState<boolean>(false);

    const handleOnClick: HtmlButtonProps['onClick'] = useCallback(
      (e) => {
        e.stopPropagation();
        toggleFavorite(item, locale);
      },
      [item, locale, toggleFavorite],
    );

    return (
      <SelectionList.Item
        key={item.id}
        value={item}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onFocus={() => setIsHovered(true)}
        className={classNames({
          [styles.item]: true,
          [styles.itemHovered]: isHovered,
          [styles.itemFavorite]: item.favorite,
        })}
      >
        <FlexBox
          key={item.id}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {!searchTerm && (
            <span className={styles.templateName}>{item.name}</span>
          )}
          {searchTerm && (
            <TextWithHighlight
              highlight={searchTerm}
              text={item.name}
              className={styles.templateName}
            />
          )}

          <div className={styles.iconButtons}>
            <IconButton
              icon={item.favorite ? 'star-full' : 'star'}
              variant="tertiary"
              iconSize={16}
              onClick={handleOnClick}
              className={styles.favoriteButton}
              tabIndex={-1}
            />
          </div>
        </FlexBox>
      </SelectionList.Item>
    );
  },
);

TemplateItem.displayName = 'TemplateItem';
